import Parse from "parse";

Parse.initialize("checkmyva");
Parse.serverURL = "https://parse-checkmyva.apps.openinc.dev/parse";
